import { theme } from 'lfs-ui/v3/layout/theme';

export const auV3Theme = {
  ...theme,
  components: {
    ...theme.components,
    Input: {
      ...theme.components?.Input,
      baseStyle: {
        ...theme.components?.Input?.baseStyle,
        field: {
          ...theme.components?.Input?.baseStyle?.field,
          color: '#0B2374',
        },
      },
    },
    CustomCheckbox: {
      baseStyle: ({ colorMode }) => {
        return {
          container: {
            _checked: {
              svg: {
                color: 'white',
                bg: '#0B2374',
              },
            },
            _focus: {},
            px: 0,
            py: 3,
          },
          icon: {
            bg: 'white',
            borderColor: '#0B2374',
            borderStyle: 'solid',
            borderWidth: 2,
            height: 5,
            mr: 4,
            padding: 2,
            width: 5,
          },
        };
      },
    },
  },
};
